import type { SelectedFile } from '../../../components/forms/FileUpload';
import type { SavedAttachment } from '../../../services/attachmentService';
import type { Request } from '../../../types';

export interface SupportingDocumentsInitialProps {
  formData: Record<string, unknown>;
  updateFormData: (field: string, value: string) => void;
  selectedFiles?: Record<string, SelectedFile[]>;
  onFilesSelected?: (section: string, files: SelectedFile[]) => void;
  offlineMode?: boolean;
  disabled?: boolean;
}

export interface SupportingDocumentsPersistedProps {
  request: Request;
  isEditing: boolean;
  editedData: Record<string, unknown>;
  updateEditedData: (field: string, value: string) => void;
  showFullDetails?: boolean;
  attachmentsBySection?: Record<string, SavedAttachment[]>;
  selectedFiles?: Record<string, SelectedFile[]>;
  onFilesSelected?: (section: string, files: SelectedFile[]) => void;
  onRefetchAttachments?: () => void;
  onDeleteAttachment?: (attachmentId: number) => void | Promise<void>;
  showViewToggle?: boolean;
  isAdvancedView?: boolean;
  onToggleView?: () => void;
  offlineMode?: boolean;
  disabled?: boolean;
  onCaptionChange?: (attachmentId: number, caption: string) => void;
  pendingCaptionEdits?: Record<number, string>;
}

export type SupportingDocumentsProps =
  | SupportingDocumentsInitialProps
  | SupportingDocumentsPersistedProps;

export function isSupportingDocumentsPersistedProps(
  p: SupportingDocumentsProps,
): p is SupportingDocumentsPersistedProps {
  return (
    'request' in p && (p as SupportingDocumentsPersistedProps).request != null
  );
}
